import React,{useEffect,useState} from 'react';
import { Grid, Box, Typography,TextField, IconButton,Button } from '@mui/material';
import { Formik,Form } from 'formik';
import { useSelector } from 'react-redux';
import { useChangeTenantInfo } from '../../Hooks';
import { changeTenantInfoFace } from '../../Interfaces/Interfaces';
import {addEmailSchema } from '../../../CompanyManagment/StaticData/index';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import FormikControl from '../../../../components/FormikControls/FormikControl';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import {ErrorMessage } from 'formik';
// import InputAdornment from '@mui/material/InputAdornment';
// import Visibility from '@mui/icons-material/Visibility';
// import VisibilityOff from '@mui/icons-material/VisibilityOff'
import "../../../CompanyManagment/Forms/RegisterTenant/Error.css"

const ChangeTenantInfo = ({ceo,onSuccesss,initialValue,editMode,onClose,setShowToastMessage}:any) => {

  const{mutate:inviteUser,data:inviteUserData,isSuccess,isError}:any=useChangeTenantInfo()
  const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
  // const userId:string=useSelector((state:any)=>state.loign.userInfo.userId);
  const [showToastMessage,setToastMessage]=useState<boolean>(false)

  const changeEmailInitialValues:changeTenantInfoFace={
    ceo:ceo,
    tenantId:tenantId
     }
  const[addChangeEmailInitialValues,setAddChangeEmailInitialValues]=useState<changeTenantInfoFace>(changeEmailInitialValues)
  const [showLtoastMessage2, setShowLtoastMessage2] = useState<any>(null);
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();

  useEffect(() => {
 if (editMode && initialValue) {
  // let{email}=initialValue;
  let initVal={
    ceo:ceo,
    tenantId:tenantId
  }
  setAddChangeEmailInitialValues(initVal)
 }
  }, [initialValue])

//   useEffect(() => {
//  if (inviteUserData) {
//   setShowToastMessage(true);
//   // handleClose();
//   // setAddStaffState(inviteUserData?.data)
//   onClose(false);
//  }  
//   }, [inviteUserData,isSuccess])

  useEffect(() => {
    if (inviteUserData) {
      if (inviteUserData?.data.isSuccess) {
        setShowToastMessage(true);
        SetIsSuccess(true);
        SetTMessage(inviteUserData?.data.metaData.message);
        onClose(false);
      } else {
        setShowLtoastMessage2(true);
        SetIsSuccess(false);
        SetTMessage(inviteUserData?.data.metaData.message);
        // setAddObjError(editKrData?.data);
      }
    }
  }, [inviteUserData]);

  useEffect(() => {
    if (isError) {
      setToastMessage(true)
    }
  }, [isError])
  
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  

    const initialSubmitForm=(data:any)=>{ 
          inviteUser({...data})
    }

    const handleClose=()=>{
      onClose((prev:any)=>false)
    }
    
  return (
    <Grid container>
   <Grid  item xs={12}  >
   <Box width={'100%'} textAlign={'center'}   >
   </Box>
   </Grid>


   <Grid item xs={12}   >
   
   <Formik enableReinitialize
    validationSchema={addEmailSchema}
    initialValues={addChangeEmailInitialValues}
    onSubmit={(data:any) => {
      initialSubmitForm(data)

    }}
  >
    {
      ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }) =>
        <Form>
          <Grid container columnSpacing={1} sx={{bgcolor: 'background.paper',mx:'auto',borderRadius:3}}   >   
          
            
            <Grid item xs={10} mx={'auto'}  >
       
            <div className='error'>
            <ErrorMessage name="email" />
            </div>
              <FormikControl
                control='textField'
                type='text'
                name='ceo'
                fullWidth
                size='ceo'                     
                value={values.ceo}
                onChange={({target}:any)=>{
                let{value}:any=target;
                setFieldValue('ceo',value)
                }}
                label={'نام شرکت'}   />
               </Grid>
       

            <Grid item xs={2} mt={1}  >
              <Box px={2} columnGap={2} display={'flex'} justifyContent={'center'} flexDirection={'row-reverse'}  >
                <Box padding={0.5}>
                  <DyButton
                    caption={'ذخیره'}
                    color={'#00387C'}
                    onClick={() => { }}
                    disbled={!dirty || !isValid}
                    variant={'contained'}
                    bgColor={'#00387C'}
                    type={'submit'}
                    onClose={false}
                  />
                </Box>
{/* 
                <Box>
                  <DyButton
                    caption={'انصراف'}
                    disbled={false}
                    variant={'outlined'}
                    onClick={handleClose}
                  />
                </Box> */}

              </Box>
            </Grid>


          </Grid>
        </Form>
    }

  </Formik>
   

   </Grid>
   {showLtoastMessage2 && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage2}
            show={showLtoastMessage2}
          />
        )}
   {
      showToastMessage && <DYToastMessage
      isSuccess={false}
      message={''}
      setShow={setShowToastMessage}
      show={showToastMessage}
      
      />
      
    }
        
    </Grid>
  )
}

export default ChangeTenantInfo